export default class ComparisonButton {
  constructor(id, name, element) {
    this.id = id
    this.name = name
    this.element = element
  }
}
